<template>
  <div class="login-page">
    <svg
      class="svgbg light-wave"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1000 500"
    >
      <path
        fill-rule="evenodd"
        fill="rgb(102, 125, 232)"
        d="M1.000,23.000 C54.176,37.648 62.875,0.531 147.000,100.000 C231.125,199.469 414.297,187.773 482.000,188.000 C549.703,188.227 878.184,188.418 1000.000,415.000 C1000.000,29.970 1000.000,23.000 1000.000,23.000 L-0.000,23.000 L1.000,23.000 Z"
      />
    </svg>
    <svg
      class="svgbg dark-wave"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1000 500"
    >
      <path
        fill-rule="evenodd"
        fill="rgb(37, 47, 92)"
        d="M1.000,23.000 C54.176,37.648 62.875,0.531 147.000,100.000 C231.125,199.469 414.297,187.773 482.000,188.000 C549.703,188.227 878.184,188.418 1000.000,415.000 C1000.000,29.970 1000.000,23.000 1000.000,23.000 L-0.000,23.000 L1.000,23.000 Z"
      />
    </svg>
    <div class="wrapper wrapper-full-page">
      <div class="login-page signup-page" v-bind:class="{ loading: loading }">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-5 col-md-7 ml-auto mr-auto">
              <!-- <form @submit.prevent="validateBeforeSubmit"> -->
              <card type="login">
                <h3 slot="header" class="header text-center" v-translate>
                  Давайте знакомиться!
                </h3>
                <small
                  class="text-danger"
                  v-for="error in errorsMessages.nonFieldErrors"
                >
                  {{ error }}
                </small>
                <div class="loader_holder">
                  <object
                    type="image/svg+xml"
                    data="/assets/loaders/infinity.svg"
                    class="loading"
                  ></object>
                </div>

                <div class="caption" v-show="!loading">Ваше заведение</div>
                <fg-input
                  v-model="form.shop_name"
                  name="shop_name"
                  type="text"
                  v-validate="'required'"
                  addon-left-icon="far fa-store"
                  :placeholder="'Название заведения' | translate"
                  :error="
                    errors.first('shop_name') || errorsMessages.shop_name[0]
                  "
                ></fg-input>
                <div class="about_input" v-show="!loading">
                  Полное красивое название.<br />Например,
                  <b>ShopingPlace Лубянка</b>
                </div>

                <div class="caption" v-show="!loading">
                  Пользователь для входа
                </div>
                <fg-input
                  v-model="form.user_name"
                  name="first_name"
                  type="text"
                  v-validate="'required|alpha'"
                  addon-left-icon="far fa-user"
                  :placeholder="'Ваше имя' | translate"
                  :error="
                    errors.first('user_name') || errorsMessages.user_name[0]
                  "
                ></fg-input>
                <fg-input
                  v-model="form.phone"
                  name="phone"
                  type="phone"
                  v-validate="'required'"
                  addon-left-icon="far fa-phone"
                  :placeholder="'Ваш номер телефона' | translate"
                  v-mask="'+7 ### ### ## ##'"
                  :error="errors.first('phone') || errorsMessages.phone[0]"
                ></fg-input>
                <fg-input
                  v-model="form.email"
                  name="email"
                  type="email"
                  v-validate="'required|email'"
                  addon-left-icon="far fa-envelope"
                  :placeholder="'Ваш Email' | translate"
                  :error="errors.first('email') || errorsMessages.email[0]"
                ></fg-input>
                <fg-input
                  v-model="form.password1"
                  name="password"
                  autocomplete="new-password"
                  type="password"
                  minlength="3"
                  v-validate="'required|length:6,20'"
                  addon-left-icon="far fa-key"
                  :placeholder="'Password' | translate"
                  ref="password"
                  :error="
                    errors.first('password') || errorsMessages.password[0]
                  "
                ></fg-input>
                <fg-input
                  v-model="form.password2"
                  name="passwordConfirm"
                  autocomplete="new-password"
                  type="password"
                  minlength="3"
                  v-validate="'required|confirmed:password'"
                  addon-left-icon="far fa-key"
                  :placeholder="'Enter password again' | translate"
                  data-vv-as="password"
                  :error="errors.first('passwordConfirm')"
                ></fg-input>
                <!-- <vue-recaptcha sitekey="6LfW3a4ZAAAAAAaszb5wpwY9SeQg3whJz2QGPLbF" :loadRecaptchaScript="true"></vue-recaptcha> -->
                <div
                  class="g-recaptcha"
                  data-sitekey="6LfW3a4ZAAAAAAaszb5wpwY9SeQg3whJz2QGPLbF"
                ></div>

                <!-- <div id='google_recaptcha'></div> -->
                <p-button
                  slot="footer"
                  type="warning"
                  round
                  block
                  class="mb-3"
                  :disabled="
                    !(
                      form.shop_name &&
                      form.password1 &&
                      form.password2 &&
                      form.email &&
                      form.user_name &&
                      form.gre
                    ) || errors.any()
                  "
                  native-type="submit"
                  @click="signup"
                >
                  <translate>Register</translate>
                </p-button>
              </card>
              <div class="additional_links">
                <router-link to="/login" v-translate
                  >Уже зарегистрированы?</router-link
                >
              </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
        <div
          class="full-page-background"
          style="
            background-image: url(/assets/img/background/nova-background.jpg);
          "
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
// import AppNavbar from './Layout/AppNavbar'
// import AppFooter from './Layout/AppFooter'
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
var apiDriver = require("../Actid/apiDriver").default;

export default {
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },
  created() {
    this.$validator.localize("ru");
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submit(e);
          return true;
        }
      });
    },
    async signup() {
      if (this.form.gre == "") return;
      this.loading = true;
      console.log(this.form);
      try {
        let signup = await apiDriver.signup(this.form);
        if (!signup) {
          this.loading = false;
          let text =
            "Произошла ошибка во время регистрации.<br>Вероятно, пользователь уже существует.<br>Обратитесь в службу поддержки dev@actid.ru";
          swal({ title: `Ошибка регистрации`, html: text, type: "error" });
        } else {
          this.$router.push("login");
          window.user_email = this.form.email;
          window.user_password = this.form.password1;
        }
      } catch (error) {
        this.loading = false;
        let text =
          "Произошла неизвестная ошибка. Обратитесь в службу поддержки dev@actid.ru";
        swal({ title: `Ошибка регистрации`, text, type: "error" });
      }
    },
    submit(e) {},
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
  },
  data() {
    return {
      loading: false,
      errorsMessages: {
        nonFieldErrors: [],
        shop_name: [],
        password: [],
        email: [],
        user_name: [],
        phone: [],
      },
      form: {
        shop_name: "",
        password1: "",
        password2: "",
        email: "",
        user_name: "",
        phone: "",
        gre: "",
      },
    };
  },
  beforeDestroy() {
    this.closeMenu();
  },
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://www.google.com/recaptcha/api.js"
    ); //?onload=vueRecaptchaApiLoaded&render=6Le83K4ZAAAAAFhaQNlsX_S2Eh4-PzLKYnUBLDgx
    document.head.appendChild(recaptchaScript);
    // let _this = this;
    // if(!window.gre_interval_installed){
    //   window.gre_interval_installed = true;
    setInterval(() => {
      if (document.location.pathname != "/signup") return;
      if (document.querySelectorAll(".g-recaptcha").length == 0) return;
      this.form.gre = window.grecaptcha.getResponse();
      // console.log(1, _this.form.gre );
    }, 500);
    // }
  },
};
</script>
<style>
.signup-page .full-page > .content {
  padding-top: 0 !important;
}
.signup-page .login-page .card-login .input-group:last-child {
  margin-bottom: 0px !important;
}
.signup-page .card {
  /* margin-bottom: 0; */
}
.signup-page {
  padding-bottom: 50px;
}

.signup-page .full-page .full-page-background {
  display: none !important;
}

.signup-page .section-image:after {
  display: none !important;
}

.signup-page .full-page-background {
  display: none !important;
}

.signup-page .full-page:after {
  display: none !important;
}

.signup-page .card-header h3 {
  color: #657de8;
  font-weight: bold;
  margin-bottom: 0px;
}
.signup-page .caption {
  text-align: center;
  text-transform: uppercase;
  color: #9a9a9a;
  font-size: 8pt;
  font-weight: bold;
  margin-bottom: 5px;
  margin-top: 20px;
}
.signup-page .about_input {
  margin-left: 55px;
  font-size: 10pt;
  margin-top: -5px;
  border-left: 1px solid #eee;
  padding-left: 10px;
  color: #4e4e4e;
}

.signup-page .card .card-body {
  padding: 15px 15px 10px 15px;
  padding-top: 0 !important;
}

.signup-page button[type="submit"] {
  background: #657de8 !important;
  color: white !important;
}

.signup-page button[type="submit"]:hover {
  background: #4c63ca !important;
  color: white !important;
}

.signup-page button[type="submit"]:active {
  background: #3a51b9 !important;
  color: white !important;
}

.dark-wave {
  display: none;
}

@media (prefers-color-scheme: dark) {
  .light-wave {
    display: none;
  }
  .dark-wave {
    display: block;
  }
}
</style>
